export const logo = require('./logoAM.png')

